import {
    CollisionEventType,
    Component,
    Object3D,
    PhysXComponent,
} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {PlayerComponent} from './player-component.js';
import {gameState} from '../state/GameState.js';

export class Region extends Component {
    static TypeName = 'region';

    @property.string('region')
    regionName = 'region';

    start(): void {
        const physx = this.object.getComponent(PhysXComponent)!;
        physx.onCollision(this._onCollision);
    }

    private _onCollision = (event: CollisionEventType, other: PhysXComponent) => {
        if (event === CollisionEventType.TriggerTouch) {
            if (!other.object.isDestroyed) {
                const player = other.object.getComponent(PlayerComponent);
                if (player) {
                    gameState.currentPlayer.enterRegion(this.regionName);
                }
            }
        }
        if (event === CollisionEventType.TriggerTouchLost) {
            if (!other.object.isDestroyed) {
                const player = other.object.getComponent(PlayerComponent);
                if (player) {
                    gameState.currentPlayer.enterRegion('');
                }
            }
        }
    };
}
